"use client";

import { useMemo } from "react";

import { cn } from "@/lib/utils";

type UpdatedLabelProps = {
  className?: string;
  label?: string;
};

export default function UpdatedLabel({ className, label }: UpdatedLabelProps) {
  const resolvedLabel = useMemo(() => {
    if (label) {
      return label;
    }

    const formatted = new Intl.DateTimeFormat("en-US", { month: "long", year: "numeric" }).format(new Date());
    return `Updated for ${formatted} Instagram Algorithm`;
  }, [label]);

  return <p className={cn("text-xs uppercase tracking-widest text-gray-500", className)}>{resolvedLabel}</p>;
}
